import { render } from "./fieldFlatpickr.vue?vue&type=template&id=45b5b0c4"
import script from "./fieldFlatpickr.vue?vue&type=script&lang=js"
export * from "./fieldFlatpickr.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__